export function arrayMove<T>(arr: T[], fromIndex: number, toIndex: number) {
    const clone = arr.slice();
    const element = clone[fromIndex];
    clone.splice(fromIndex, 1);
    clone.splice(toIndex, 0, element);
    return clone;
}